var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert",class:{
    'alert-success': _vm.type_id == 1,
    'alert-warning': _vm.type_id == 2,
    'alert-danger': _vm.type_id == 3
  }},[_c('span',{class:{
      'text-danger': _vm.type_id == 3
    }},[_c('b',{staticClass:"text-uppercase"},[_vm._v(_vm._s(_vm.alert))])])])}
var staticRenderFns = []

export { render, staticRenderFns }